module.exports = __webpack_public_path__ + "media/2.4123c3a3.mp3";